<template>
  <div class="body">
    <div class="main">
      <div class="wrap">
        <div class="card">
          <div class="title">教师基础信息导入</div>
          <div class="box" style="justify-content: space-between">
            <div class="btn btn-1">
              <el-upload
                :action="$_axios2.defaults.baseURL + '/api/teacher/account/import-info'"
                :before-upload="beforeUpload"
                :headers="{ authorization: 'Bearer ' + $store.getters.token }"
                :on-success="onSuccess"
                :show-file-list="false"
                accept=".xlsx,.xls"
                class="upload-demo">
                <el-button type="primary">
                  <i class="el-icon-upload2"></i>
                  导入
                </el-button>
              </el-upload>
            </div>
            <div class="btn" @click="show2 = true">
              <i class="el-icon-download"></i>
              <a :href="$OssAddress + 'preview/%E6%95%99%E8%81%8C%E5%B7%A5%E8%B4%A6%E5%8F%B7%E4%BF%A1%E6%81%AF%E6%94%B6%E9%9B%86%20.xlsx'">下载模版</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  _config: { route: { path: "index", meta: { title: "列表" } } },
  name: "Index",
  data() {
    return {
      data: {
        admin_menu: [],
        teaching_menu: [],
      },
      defaultProps: {
        children: "child",
        label: "name",
      },
      errorStr: [],
    };
  },
  methods: {
    onSuccess(response) {
      this.errorStr = [];
      if (response.status === 0) {
        this.$message.success(response.msg);
      } else {
        this.errorStr = response.data;
        this.$message.error(response.msg);
      }
    },

    beforeUpload(file) {
      const testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "xls";
      const extension2 = testmsg === "xlsx";
      if (!extension && !extension2) {
        this.$message({
          message: "上传文件只能是xls、xlsx格式!",
          type: "warning",
        });
      }
      return extension || extension2;
    },
  },
};
</script>

<style scoped lang="scss">
.el-checkbox {
  width: 98rem;
}

.el-checkbox-group .el-checkbox {
  margin-top: 20rem;
}

.el-upload {
  display: block;
}

.el-button--primary {
  background-color: #326fff;
  border-color: #326fff;
}

.el-button--primary.is-disabled {
  background-color: #ccc;
  border-color: #ccc;
}

.el-button--primary.is-disabled:hover {
  color: #fff;
}

.body {
  height: 100%;
  background-color: #f7f7f7 !important;

  .main {
    background-color: #fff;

    .wrap {
      padding: 32rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      max-width: 1500rem;
      min-width: 1170rem;
    }

    .card {
      background-color: #f6f9ff;
      padding: 12rem 35rem 35rem 30rem;
      width: 300rem;
      margin-left: 30rem;
      border-radius: 4rem;

      &:first-child {
        margin-left: 0;
      }

      .title {
        color: #1e3aa2;
        font-size: 16rem;
        font-weight: 600;
      }

      .box {
        display: flex;
        justify-content: center;
        margin-top: 50rem;

        .btn {
          width: 88rem;
          height: 40rem;
          color: #326fff;
          border: 1rem solid #326fff;
          background-color: transparent;
          border-radius: 4rem;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;

          p {
            margin-left: 4rem;
            font-size: 14rem;
          }
        }

        .btn-1 {
          background: #326fff;
          color: #fff;
        }
      }
    }
  }
}

.t-btn {
  padding: 0 16rem;
  background-color: #326fff;
  height: 32rem;
  line-height: 32rem;
  display: flex;
  align-items: center;
  border-radius: 4rem;
  cursor: pointer;

  p {
    color: #fff;
    font-weight: 500;
  }

  i {
    margin-right: 4rem;
    color: #fff;
  }
}

.p1 {
  color: #333;
  font-size: 16rem;
  font-weight: 600;
}

.p2 {
  color: #666;
  margin-top: 10rem;
}

.p3 {
  color: #333;
  font-size: 16rem;
  font-weight: 500;
}

.p4 {
  font-size: 14rem;
  color: #666;
  margin-top: 12rem;
  padding-left: 12rem;
  position: relative;

  &:before {
    content: "";
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    background-color: #1c4efd;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }
}

.dia-top {
  background: #f6f9ff;
  border-radius: 4rem;
  padding: 20rem 24rem;

  .box {
    margin-top: 20rem;
    display: flex;
  }
}

.dia-main {
  margin-top: 24rem;
  background: #f6f9ff;
  border-radius: 4rem;
  padding: 20rem 24rem;
}

.form-item {
  margin-top: 24rem;
  display: flex;
  align-items: center;
  height: 32rem;

  span {
    width: 120rem;
    font-weight: bold;
    font-size: 16rem;
    color: #333;
  }

  .el-button {
    background-color: #fff;
    border-color: #dbdde4;
    color: #ccc;
    padding-top: 0;
    padding-bottom: 0;
    height: 32rem;
    line-height: 32rem;
    font-size: 14rem;
  }
}

.select-box {
  display: flex;
  align-items: center;
}

.box-item {
  display: flex;
  align-items: center;
  margin-right: 40rem;

  span {
    color: #333;
    font-size: 16rem;
  }
}

.w-160 {
  width: 160rem;
  margin-left: 20rem;
}

.main-box {
  border: 1rem solid #dbdde4;
  display: flex;
  margin-top: 30rem;

  .left {
    padding: 24rem;
    flex: 1;
    max-height: 465rem;
    overflow-y: scroll;
  }

  .right {
    width: 260rem;
    min-width: 260rem;
    padding: 24rem;
    border-left: 1rem solid #dbdde4;
    max-height: 465rem;
    overflow-y: scroll;
  }
}
</style>
